var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element-content",style:(_vm.elementStyle),on:{"mouseover":_vm.onMouseOver,"mouseout":_vm.onMouseOut}})}
var staticRenderFns = []

export { render, staticRenderFns }